import React, { useEffect } from "react";
import NavBar from "./NavBar";
import { Outlet } from "react-router-dom";
import {
  DASHBOARD_SIDEBAR_ID,
  useNavbarContext,
  useNavCounts,
} from "../../context/NavbarContext";
import FeedbackWidget from "../Feedback/FeedbackWidget";

const DashboardBFC = (props: any) => {
  const { isNavbarOpen } = useNavbarContext();
  const { refreshNavCounts } = useNavCounts();

  // The NavBars share one fetch per page load; coming back to the dashboard
  // (e.g. after validating a case) fetches the badge counts again.
  useEffect(() => {
    refreshNavCounts();
  }, [refreshNavCounts]);

  // The Outlet keeps its place in the tree in both layouts, so toggling the
  // column does not remount the page.
  return (
    <div>
      <div
        className={
          isNavbarOpen
            ? "grid grid-cols-1 lg:grid-cols-5 gap-5"
            : "grid grid-cols-5 gap-5"
        }
      >
        {/* min-h (not a fixed grid row) so the white panel grows with the nav
            list — a fixed 850px row let the last items spill out of the card.
            Below `lg` the nav lives in Layout's drawer, so the column is hidden
            with CSS (kept mounted: resizing or rotating across 1024 px does
            not remount it) and the page gets the full width. */}
        {isNavbarOpen && (
          <nav
            id={DASHBOARD_SIDEBAR_ID}
            aria-label="Main navigation"
            className="hidden lg:block col-span-1 min-w-0"
          >
            <div className="min-h-[850px] h-auto bg-white rounded-lg shadow-md">
              <NavBar />
            </div>
          </nav>
        )}

        {/* col-span-4 only once the 5-column track exists; below `lg` the grid
            is 1 column and a span-4 item would create 4 implicit auto-width
            columns, pushing the content out of the page container. */}
        <div
          className={
            isNavbarOpen
              ? "col-span-1 lg:col-span-4 min-w-0"
              : "col-start-1 col-span-5"
          }
        >
          <Outlet />
        </div>
      </div>
      <FeedbackWidget />
    </div>
  );
};

export default DashboardBFC;
